<template>
  <div id="cover" @click="removeOpacity"></div>
</template>

<script>
import { CLOSE_NAVIGATION_DRAWER } from '@/helpers/eventBus'

export default {
  name: 'OpacityCover',
  methods: {
    removeOpacity() {
      this.$eventBus.$emit(CLOSE_NAVIGATION_DRAWER)
    }
  }
}
</script>

<style lang="scss" scoped>
#cover {
  position: absolute;
  min-width: 100%;
  min-height: 100%;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.4);
  top: 0;
  left: 0;
}
</style>
